import styled from 'styled-components';
import Badge from 'components/Badge';

export const StyledCallTypeBadge = styled(Badge)`
    text-transform: none;
    padding: 0.25rem 0.35rem;
    line-height: 1.35 !important;
    height: fit-content !important;
    text-transform: unset;
    font-weight: 400;
    letter-spacing: 0;

    span {
        display: flex;
        align-items: center;
        line-height: 100%;
    }
`;
